/* unplugin-vue-components disabled */import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=998d0124&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-998d0124"]])

export default __exports__